export default __webpack_public_path__ + "static/media/Biz Development News.26b8cff3.png";